import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

export const useRedirect = () => {
  const dispatch = useDispatch();
  return path => () => {
    dispatch(push(path));
  };
};
